<template>
  <div class="box">
    <div class="row">
      <div class="col-lg-8 box-img-wrapper">
        <VideoWrapper v-if="box.videoURL" :videoLink="box.videoURL"></VideoWrapper>
        <ImageWrapper v-else :file="box.idFile" :key="box.idFile"></ImageWrapper>
      </div>
      <div class="col-lg-4 box-inner">
        <span class="box-tag">
          <span>{{ box.date | formatDate2 }}</span>
          <span>{{ category ? category.value : 'Solution' }}</span>
        </span>
        <router-link v-if="slug" :to="{name: 'SolutionProcess', params: {slug: slug, id: box.idSolution}}" class="box-title">
          <span>{{ box.headline }}</span>
        </router-link>
        <router-link v-else :to="{name: 'SolutionProcessSingle', params: {id: box.idSolution}}" class="box-title">
          <span>{{ box.headline }}</span>
        </router-link>
        <p class="home-solution" v-html="box.lead"></p>
      </div>
    </div>
  </div>
</template>
<script>
import ImageWrapper from "@/components/general/ImageWrapper";
import {readTime} from "@/helpers/readTime";
import {slugify} from "@/helpers/slugify";
import VideoWrapper from "@/components/general/VideoWrapper";
export default {
  name: 'HomeSolutionBox',
  components: {VideoWrapper, ImageWrapper},
  props: ['box'],
  methods: {
    readTime: readTime
  },
  computed: {
    category() {
      if (this.box.idCategory) {
        return  this.$store.getters.customCompanyContentCategories([this.box.idCategory])[0]
      }
      return this.$store.getters.sectionByIdSettingCompany(this.box._embedded.Content.idType)
    },
    slug() {
      return  this.category ? slugify(this.category.value) : null
    }
  }
}
</script>
